import { SbkElement } from '../../configuration/sbk-element.ts';
import {customElement, query} from "lit/decorators.js";
import {SbkButton} from "@/components/button/button.ts";

@customElement('sbk-javascript-bridge')
export class SbkJavascriptBridge extends SbkElement {

    @query('#QRCodeScan')
    _qrCodeSubmitButton!: SbkButton

    protected createRenderRoot() {
        return this;
    }

    connectedCallback() {
        super.connectedCallback();

        this._qrCodeSubmitButton.addEventListener('click', (e) => {
            e.preventDefault()
            this._onSubmitQrCode();
        })
    }

    _onSubmitQrCode() {
        const newBridgeData = '{"eebIsClicked":{}}';
        if (navigator.userAgent.includes("iPhone")) {
            // @ts-expect-error only used by iPhones
            window.webkit.messageHandlers["AppNotifier"].postMessage(newBridgeData);
        } else {
            // @ts-expect-error only used by Android phones
            AppNotifier.postMessage(newBridgeData);
        }
    }
}
